<div class="card-container">
  <nz-tabset nzType="card">
    <nz-tab [nzTitle]="'Users' | translate">
      <app-users-management></app-users-management>
    </nz-tab>
    <nz-tab *ngFor="let group of configurationGroups" [nzTitle]="group.name">
      <app-configuration-group
        [configurationsGroup]="group"
      ></app-configuration-group>
    </nz-tab>

    <nz-tab [nzTitle]="'Language' | translate">
      <p>Current Language: {{ selectedLanguage  | languageName  }}</p> 

    <nz-select [(ngModel)]="selectedLanguage" (ngModelChange)="changeLanguage($event)"
      class="language-select" style="width:100%;">
       <nz-option nzValue="en" nzLabel="English"></nz-option>
       <nz-option nzValue="fr" nzLabel="Français"></nz-option>
       <nz-option nzValue="es" nzLabel="Español"></nz-option>
       <nz-option nzValue="de" nzLabel="Deutsch"></nz-option>
     </nz-select>
    </nz-tab>
  </nz-tabset>
</div>
